export default __webpack_public_path__ + "static/living-in-stl-622cb50a40027b781ee8b23bf7e4672b.jpg";